import React, {FC} from "react"
import Sticky from "react-sticky-el"

import {Body} from "@irati/ui/src/Typography"
import Flex from "@irati/ui/src/Flex"
import {useTheme} from "@irati/ui/src/global/useTheme"
import FormattedMessage, {injectIntl, InjectIntl} from "@irati/utils/lang"
import Loading from "@irati/ui/src/Loading"
import {RenewalOption} from "@irati/types"
import Card from "@irati/ui/src/Layout/Card"
import {ValidationButton} from "@irati/ui/src/FormItem"
import {CurrencyType} from "@irati/payments/enums"

import NewRenewalCard from "../../../NewRenewalCard"
import MonthlyPrice from "../../../NewRenewalCard/MonthlyPrice"
import PriceLoader from "./PriceLoader"

interface Props extends InjectIntl {
  load: Promise<void> | null
  onShowConfirmRenewalDetails: () => void
  quotes?: RenewalOption[]
  selectedQuote?: RenewalOption
  onUpdateSelected: (q: RenewalOption) => void
  currencyCode: CurrencyType
  hasError: boolean
}

const NewRenewalCards: FC<Props> = ({
  load,
  onShowConfirmRenewalDetails,
  quotes,
  selectedQuote,
  onUpdateSelected,
  currencyCode,
  hasError
}) => {
  const theme = useTheme()
  return (
    <Flex width="550px" direction="column">
      <Sticky stickyStyle={{marginTop: theme.spacing.two}}>
        <Card bgColor={theme.colors.primary2} marginBottom={2} padding={2}>
          <Loading load={load} Loader={() => <PriceLoader load={load} />}>
            <Flex direction="column" gap={theme.spacing.half}>
              {quotes?.map((quote, i) => (
                <NewRenewalCard
                  key={i}
                  quote={quote}
                  isSelected={quote.termLength === selectedQuote?.termLength}
                  onUpdate={onUpdateSelected}
                  isRecommended={quote?.termLength === 24}
                  oneYearQuote={i === 0 ? undefined : quotes?.find((q) => q.termLength === 12)}
                  currencyCode={currencyCode}
                />
              ))}
            </Flex>
            <MonthlyPrice
              originalCost={quotes[0]?.costPerSeatMonth}
              savingsCost={selectedQuote?.costPerSeatMonth}
              currencyCode={currencyCode}
              invert
            />
            <ValidationButton primary onClick={onShowConfirmRenewalDetails} full marginTop={2} disabled={hasError}>
              <FormattedMessage id="admin.billing.renewals.newPlan.confirm" />
            </ValidationButton>
          </Loading>
        </Card>
        <Body small>
          <FormattedMessage id="admin.billing.renewals.newPlan.hint" />
        </Body>
      </Sticky>
    </Flex>
  )
}

export default injectIntl(NewRenewalCards)
